import * as React from 'react';

interface IProps {
    active: number,
}

export function IconGrid(props: IProps) {
    return (
        <svg width={20} height={20} viewBox="0 0 20 20" {...props}>
            <path
                data-name="Carrousel View Icon copy 2"
                d="M.5.5h5v5h-5v-5zm7 0h5v5h-5v-5zm7 0h5v5h-5v-5zm-14 7h5v5h-5v-5zm7 0h5v5h-5v-5zm7 0h5v5h-5v-5zm-14 7h5v5h-5v-5zm7 0h5v5h-5v-5zm7 0h5v5h-5v-5z"
                fill="none"
                stroke={props.active ? '#2aaef5' : '#999'}
            />
        </svg>
    );
}




// WEBPACK FOOTER //
// ./src/Pages/PhotoViewer/IconGrid.tsx